module.exports = __webpack_public_path__ + "static/media/Ok.b1a100c5.svg";